import { useEffect, useState } from "react";
import GuestRouter from "./pages/GuestRouter";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthApi } from "./utils/api/auth";
import { useUserStore } from "./store/useUserStore";
import PrivateRoute from "./pages/PrivateRouter";
import Splash from "./components/Splash";
import Navbar from "./components/Navbar";
import moment from "jalali-moment";
import "leaflet/dist/leaflet.css";
import { sendFCMTokenToServer } from "./utils/firebase/tokenManager";

function App() {
  moment.locale("fa");
  const { user, clearUser, setUser, setAvg } = useUserStore();
  const [showSplash, setShowSplash] = useState<boolean>(true);

  useEffect(() => {
    setTimeout(() => {
      setShowSplash(false);
    }, 2000);
    AuthApi.profile()
      .then((res: any) => {
        setUser(res.data);
      })
      .catch((err) => {
        if ([400, 401, 403].includes(err.status)) {
          clearUser();
        }
      });
  }, []);
  useEffect(() => {
    AuthApi.avgScore().then((res) => {
      setAvg(res.data.averageScore);
    });
  }, [user]);

  useEffect(() => {
    if (user && user.id) {
      setTimeout(() => {
        sendFCMTokenToServer(user.id).catch((error) => {
          console.error("خطا در ارسال توکن Firebase:", error);
        });
      }, 1000);
    }
  }, [user]);

  return (
    <div className={`max-w-[500px] bg-[#f9fafb] mx-auto min-h-[900px] relative ${user ? "pb-28" : ""}`}>
      <Router>
        {showSplash && <Splash />}
        {user ? (
          <div className="px-4 pt-4 lg:mt-0">
            <PrivateRoute />
            <Navbar />
          </div>
        ) : (
          <GuestRouter />
        )}
        <ToastContainer rtl />
      </Router>
    </div>
  );
}

export default App;
